import "./style.css"

function ModalReferences() {
    return (
        <div className='modal modal_categories'>
            
        </div>
    )
}

export default ModalReferences;